import {ScrollContext} from '../dropdownVirtualList';

export const computeIsNearBottomOfScollableList = (scrollContext: ScrollContext) => {
  const {scrollTop, clientHeight, scrollHeight} = scrollContext;

  return scrollTop + clientHeight > scrollHeight - 50;
};
